/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: 0 auto ${pxToRem(spacing.xxxl)};
`;
